import { FunctionalArea } from '../../../../insights/types/InsightsTypes';
import { DocumentNode } from 'graphql/index';
import {
  BaseApplicationProperty,
  MutationStatus,
} from '../updateApplication/BaseApplicationProperty';
import { gql } from '@apollo/client/core';
import { MyApp } from '../../../types/myAppTypes';

/**
 * GraphQL mutation for updating functional area connections.
 */
export const UpdateFunctionalAreaConnections = gql`
  mutation UpdateFunctionalAreaConnections(
    $input: [UpdateFunctionalAreaConnectionInput!]!
  ) {
    devhub {
      connections {
        functionalArea {
          updateFunctionalAreaConnections(input: $input) {
            applicationId
            success
            message
          }
        }
      }
    }
  }
`;

export type UpdateFunctionalAreasMutationResult = {
  devhub: {
    connections: {
      functionalArea: {
        updateFunctionalAreaConnections: MutationStatus[];
      };
    };
  };
};

/**
 * Class representing a property for adding a functional area connection.
 */
export class AddFunctionalAreaConnectionProperty implements BaseApplicationProperty {
  field: string;
  value?: FunctionalArea;
  label: string = 'Functional Area';

  constructor(field: string) {
    this.field = field;
  }

  /**
   * Sets the value of the functional area.
   * @param value - The functional area to set.
   */
  set(value: FunctionalArea) {
    this.value = value;
  }

  /**
   * Generates the mutation input for the functional area property.
   * @returns An object containing the functional area ID.
   */
  propertyMutationInput() {
    return {
      functionalAreaId: this.value?.id,
    };
  }

  /**
   * Returns the GraphQL mutation query for updating functional area connections.
   * @returns The GraphQL mutation query document node.
   */
  mutationQuery(): DocumentNode {
    return UpdateFunctionalAreaConnections;
  }
  /**
   * Extracts the mutation result from the response data.
   * @param data - The result data from the mutation.
   * @returns The mutation status array.
   */
  getMutationResult(data: UpdateFunctionalAreasMutationResult) {
    return data?.devhub?.connections?.functionalArea
      ?.updateFunctionalAreaConnections;
  }

  /**
   * Returns the current display value of the functional area for the given application.
   * @param app - The application object containing the functional area.
   * @returns The display value of the functional area.
   */
  getCurrentDisplayValue(app: MyApp): string {
    return `${app?.functionalArea}`;
  }

  /**
   * Returns the display value for the new functional area.
   * @returns The name of the functional area.
   */
  getNewDisplayValue(): string {
    return `${this.value?.name}`;
  }
}
